import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-inbox-up',
  templateUrl: './icon-inbox-up.component.html',
  styleUrls: ['./icon-inbox-up.component.scss']
})
export class IconInboxUpComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;
  
  constructor() { }

  ngOnInit() {
  }

}
